import { resolveComponent as _resolveComponent, withKeys as _withKeys, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-7ce76784"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "search-result page-content"
};
const _hoisted_2 = {
  class: "flex-container"
};
const _hoisted_3 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("hr", null, null, -1));
const _hoisted_4 = {
  class: "t-table-wrapper"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_sic_selector = _resolveComponent("sic-selector");
  const _component_el_tab_pane = _resolveComponent("el-tab-pane");
  const _component_el_input = _resolveComponent("el-input");
  const _component_el_tabs = _resolveComponent("el-tabs");
  const _component_el_button = _resolveComponent("el-button");
  const _component_el_col = _resolveComponent("el-col");
  const _component_t_filter = _resolveComponent("t-filter");
  const _component_t_table_select_column = _resolveComponent("t-table-select-column");
  const _component_company_name_column = _resolveComponent("company-name-column");
  const _component_company_info_column = _resolveComponent("company-info-column");
  const _component_t_table_operation_column = _resolveComponent("t-table-operation-column");
  const _component_t_table = _resolveComponent("t-table");
  const _component_t_loadmore = _resolveComponent("t-loadmore");
  return _openBlock(), _createElementBlock("div", _hoisted_1, [_createVNode(_component_t_filter, {
    filters: _ctx.filterItems,
    value: _ctx.filterData,
    onChange: _ctx.onTFilterChange
  }, {
    default: _withCtx(() => [_createVNode(_component_el_col, {
      span: 24,
      class: "filter-tabs-wrapper"
    }, {
      default: _withCtx(() => [_createElementVNode("div", _hoisted_2, [_createVNode(_component_el_tabs, {
        modelValue: _ctx.selectedFilterTab,
        "onUpdate:modelValue": _cache[5] || (_cache[5] = $event => _ctx.selectedFilterTab = $event),
        class: "filter-tabs",
        onTabClick: _ctx.handleTabClick
      }, {
        default: _withCtx(() => [_createVNode(_component_el_tab_pane, {
          label: "潜客信息",
          name: "sic"
        }, {
          default: _withCtx(() => [_createVNode(_component_sic_selector, {
            ref: "sicSelectorRef",
            sic: _ctx.bufferedFilterData.sic,
            "onUpdate:sic": _cache[0] || (_cache[0] = $event => _ctx.bufferedFilterData.sic = $event),
            "buyer-product": _ctx.bufferedFilterData.buyerProduct,
            "onUpdate:buyerProduct": _cache[1] || (_cache[1] = $event => _ctx.bufferedFilterData.buyerProduct = $event),
            "init-sic-options": _ctx.initSicOptions,
            onKeydown: _cache[2] || (_cache[2] = _withKeys($event => !_ctx.searchDisabled && _ctx.handleSearchBtnClick(), ["enter"]))
          }, null, 8, ["sic", "buyer-product", "init-sic-options"])]),
          _: 1
        }), _createVNode(_component_el_tab_pane, {
          label: "主营产品",
          name: "product"
        }, {
          default: _withCtx(() => [_createVNode(_component_el_input, {
            modelValue: _ctx.bufferedFilterData.product,
            "onUpdate:modelValue": _cache[3] || (_cache[3] = $event => _ctx.bufferedFilterData.product = $event),
            placeholder: "请用英文填写产品名称或HS Code",
            onKeydown: _cache[4] || (_cache[4] = _withKeys($event => !_ctx.searchDisabled && _ctx.handleSearchBtnClick(), ["enter"]))
          }, null, 8, ["modelValue"])]),
          _: 1
        })]),
        _: 1
      }, 8, ["modelValue", "onTabClick"]), _createVNode(_component_el_button, {
        type: "primary",
        disabled: _ctx.searchDisabled || _ctx.disableMiningAction,
        loading: _ctx.tableLoading,
        onClick: _ctx.handleSearchBtnClick
      }, {
        default: _withCtx(() => [_createTextVNode("查询")]),
        _: 1
      }, 8, ["disabled", "loading", "onClick"])]), _hoisted_3]),
      _: 1
    })]),
    _: 1
  }, 8, ["filters", "value", "onChange"]), _createElementVNode("div", _hoisted_4, [_createVNode(_component_t_table, {
    ref: "TTableRef",
    data: _ctx.tableData,
    loading: _ctx.tableLoading && !_ctx.tableData.length,
    "row-key": "companyId",
    onSelectionChange: _ctx.handleSelectionChange
  }, {
    tableToolBox: _withCtx(() => [_createVNode(_component_el_button, {
      loading: _ctx.disableMiningAction,
      size: "small",
      onClick: _ctx.handleDataTrial
    }, {
      default: _withCtx(() => [_createTextVNode("挖掘联系人")]),
      _: 1
    }, 8, ["loading", "onClick"])]),
    default: _withCtx(() => [_createVNode(_component_t_table_select_column, {
      "reserve-selection": ""
    }), _createVNode(_component_company_name_column, {
      "filter-data": _ctx.filterData,
      onNameClick: _ctx.handleCompanyNameClick
    }, null, 8, ["filter-data", "onNameClick"]), _createVNode(_component_company_info_column), _createVNode(_component_t_table_operation_column, {
      buttons: [{
        text: '挖掘联系人',
        onClick: _ctx.handleDataTrial,
        disabled: row => row !== null && row !== void 0 && row.loading ? false : _ctx.disableMiningAction,
        loading: row => row !== null && row !== void 0 && row.loading ? true : false
      }],
      width: "236"
    }, null, 8, ["buttons"])]),
    _: 1
  }, 8, ["data", "loading", "onSelectionChange"])]), _createVNode(_component_t_loadmore, {
    status: _ctx.loadMoreStatus,
    onCurrentChange: _ctx.handleLoadMoreCurrentChange
  }, null, 8, ["status", "onCurrentChange"])]);
}